<template>
  <div>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="60px"
          inline
          size="small"
          @submit.native.prevent
        >
          <el-form-item label="关键字">
            <el-input
              v-model="filter.keyword"
              placeholder="标题"
              @keyup.enter.native="requestSearch"
            ></el-input>
          </el-form-item>
          <el-form-item label="设备分类">
            <item-category-select
              :val="filter.item_category_id"
              :category="2"
              @change="filter.item_category_id = $event"
            ></item-category-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="requestSearch"
              >筛选</el-button
            >
            <el-button size="small" @click="requestSearch('reset')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="panel mt-20">
      <div class="header">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          v-permission="type == 1 ? Auth.wikiNew : Auth.commodityActivityManage"
          @click="handleEdit"
          >新增{{ type == 2 ? '市场活动' : '知识库' }}</el-button
        >
      </div>

      <el-table :data="list" v-loading="loading" stripe style="width: 100%">
        <el-table-column align="left" label="标题" prop="title" min-width="200">
          <template slot-scope="scope">
            <div class="pointer text-primary" @click="showDetail(scope.row)">
              {{ scope.row.title }}
              <el-tag type="primary" size="mini" v-if="scope.row.tag">{{
                scope.row.tag
              }}</el-tag>
            </div>
            <div>
              <el-tag
                type="info"
                size="mini"
                v-for="item in scope.row.item_category_names"
                :key="item"
                >{{ item.replace(/,/g, '-') }}</el-tag
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="有效期" min-width="120">
          <template slot-scope="scope">
            {{
              scope.row.start_date
                ? `${scope.row.start_date} 至 ${scope.row.end_date}`
                : '无'
            }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="是否公开" v-if="type == 1">
          <template slot-scope="scope">
            {{ scope.row.is_public == 2 ? '否' : '是' }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="正文形式">
          <template slot-scope="scope">
            {{ scope.row.content_type == 1 ? '网页链接' : '自定义' }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="创建人" prop="user.name">
        </el-table-column>
        <el-table-column align="left" label="编辑时间" prop="updated_at">
          <template slot-scope="scope">
            {{ $time(scope.row.updated_at).format('YYYY-MM-DD HH:mm') }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态">
          <template slot-scope="scope">
            <status-tag
              :type="scope.row.status == 2 ? 'success' : 'gray'"
              :name="scope.row.status == 2 ? '已发布' : '草稿'"
            ></status-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="250">
          <template slot-scope="scope">
            <el-popconfirm
              v-if="scope.row.status == 1"
              v-permission="
                type == 1 ? Auth.wikiDelete : Auth.commodityActivityManage
              "
              title="确认删除吗？"
              @confirm="handleDelete(scope.$index, scope.row.id)"
            >
              <el-button slot="reference" type="danger" plain size="mini"
                >删除</el-button
              >
            </el-popconfirm>
            <el-popconfirm
              class="ml-5"
              v-permission="
                type == 1 ? Auth.wikiStatus : Auth.commodityActivityManage
              "
              :title="`确认${scope.row.status == 1 ? '发布' : '撤回'}吗？`"
              @confirm="handleSwitchStatus(scope.$index, scope.row.id)"
            >
              <el-button slot="reference" type="primary" plain size="mini">{{
                scope.row.status == 1 ? '发布' : '撤回'
              }}</el-button>
            </el-popconfirm>
            <el-button
              class="ml-5"
              type="primary"
              plain
              size="mini"
              @click="handleEdit(scope.$index, scope.row)"
              v-permission="
                type == 1 ? Auth.wikiEdit : Auth.commodityActivityManage
              "
              v-if="scope.row.status == 1"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        @current-change="handlePageChange"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>

    <ModelFormer
      :model="model"
      :show.sync="itemFormerVisible"
      @created="createdCallback"
      @updated="updatedCallback"
    ></ModelFormer>

    <ModelDetail :model="showItem" :show.sync="detailDialog"></ModelDetail>
  </div>
</template>

<script>
import { wikiList, updateWikiStatus, deleteWiki } from '@/service/getData'
import ModelFormer from './former'
import ItemCategorySelect from '@/components/select/item_category_select'
import ModelDetail from './detail.vue'

export default {
  props: {
    type: Number,
  },
  components: {
    ModelFormer,
    ItemCategorySelect,
    ModelDetail,
  },
  data() {
    return {
      loading: false,
      model: {},
      itemFormerVisible: false,
      editIndex: 0,
      list: [],
      total: 0,
      filter: {
        size: 20,
        page: 1,
        status: 0,
        keyword: '',
        item_category_id: '',
        type: this.type,
      },
      showItem: {},
      detailDialog: false,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      let params = this.clone(this.filter)
      params.page -= 1

      let res = await wikiList(params)
      if (res.code == 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.loading = false
      }
    },
    handlePageChange(e) {
      this.filter.page = e
      this.getData()
    },
    requestSearch(reset = '') {
      this.filter.page = 1
      if (reset == 'reset') {
        this.filter.status = 0
        this.filter.keyword = ''
        this.filter.item_category_id = ''
      }
      this.getData()
    },
    createdCallback(data) {
      this.list.unshift(data)
    },
    updatedCallback(data) {
      this.$set(this.list, this.editIndex, data)
    },
    handleEdit(index, item) {
      if (item) {
        this.editIndex = index
        this.model = this.clone(item)
      } else {
        this.model = {
          title: '',
          type: this.type,
          item_category_ids: [],
          content: '',
          content_type: 1,
          is_public: this.type == 2 ? 1 : '',
          tag: '',
        }
      }
      this.itemFormerVisible = true
    },
    async handleSwitchStatus(index, id) {
      let res = await updateWikiStatus(id)
      if (res.code == 0) {
        this.list[index].status = res.data.status
      }
    },
    async handleDelete(index, id) {
      let res = await deleteWiki(id)
      if (res.code == 0) {
        this.list.splice(index, 1)
      }
    },
    showDetail(item) {
      this.showItem = item
      this.detailDialog = true
    },
  },
}
</script>

<style scoped>
.flex-row-between {
  align-items: flex-start;
}
</style>